import { initSubRoutes } from '../../../../utils/router';

const RoutesCreerCompteEtape2 = initSubRoutes({
    route: '/etape-2/:token',
    subroutes: {},
    nom: 'Création de compte - Deuxième partie',
});

export default RoutesCreerCompteEtape2;
